import React from "react"
import Table from "material-ui/Table"
import TableHeaderColumn from "material-ui/Table/TableHeaderColumn"
import TableRow from "material-ui/Table/TableRow"
import TableHeader from "material-ui/Table/TableHeader"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import TableBody from "material-ui/Table/TableBody"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../../components/layout/TableFooter"
import strings from "../../../localization/strings"
import MapColumn from "../../../components/map/MapColumn"
import EmployeeNameColumn from "./EmployeeNameColumn"
import CircularProgress from "material-ui/CircularProgress"
import * as userActions from "../../../actions/UserActions"
import * as hierarchyHelper from "../../../helpers/hierarchyHelper"
import { IEquipmentMetaData, IUserDocument } from "../../../models"
import autobind from "class-autobind"
import { grey500 } from "material-ui/styles/colors"
import ClientLocalDateTimeStr from "../../../components/common/ClientLocalDateTimeStr"

interface IProps {
    history: IEquipmentMetaData[]
}
interface IState {
    history: IEquipmentMetaData[]
    loadingData: boolean
    limit: number
    offset: number
    total: number
    showingHistory: IEquipmentMetaData[]
    employees: IUserDocument[]
}

const styles = {
    columnValue: {
        textAlign: "center",
        cursor: "pointer"
    },
    columnHeader: {
        textAlign: "center"
    },
    bodyStyle: {
        height: "calc(100vh - 400px)",
        overflowY: "visible"
    }
}

const equipmentHistoryTableHeaders = ["Date_Time", "Location", "GPS", "Employee", "Note"]
const limitOptions = [20, 50, 100]

export default class EquipmentHistoryTable extends React.PureComponent<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            history: props.history,
            loadingData: false,
            limit: limitOptions[0],
            offset: 0,
            total: props.history.length,
            showingHistory: [],
            employees: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getShowingHistory()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            history: nextProps.history,
            offset: 0,
            total: nextProps.history.length
        }, () =>
            this.getShowingHistory()
        )
    }

    getShowingHistory() {
        const { limit, offset, history } = this.state
        if (history.length === 0) return
        const end = limit + offset > history.length ? history.length : limit + offset
        const showingHistory = history.slice(offset, limit + offset)
        this.setState({ loadingData: true, showingHistory }, () => {
            const employeeIds = []
            showingHistory.forEach((item) => {
                if (employeeIds.indexOf(item.EmployeeId) === -1) employeeIds.push(item.EmployeeId)
            })
            const getEmployees = []
            employeeIds.forEach((item) => {
                const getEmployee = new Promise(
                    (resolve) => {
                        userActions.loadUser(item).then((res) => resolve(res.data))
                    }
                )
                getEmployees.push(getEmployee)
            })

            Promise.all(getEmployees).then((result) => {
                this.setState({
                    employees: result,
                    loadingData: false
                })
            })
        })
    }

    getLevelName(levelId) {
        return hierarchyHelper.getFullyQualifiedLevelNameById(levelId)
    }

    onLimitChange(limit) {
        this.setState({
            offset: 0,
            limit
        }, () =>
            this.getShowingHistory()
        )
    }

    onPageClick(offset) {
        this.setState({ offset }, () =>
            this.getShowingHistory()
        )
    }

    render() {
        return (
            <div style={{ textAlign: "center", marginTop: 20 }}>
                {this.props.history && this.props.history.length === 0 ?
                    <span style={{ fontSize: 20 }}>{strings.This_equipment_has_not_history}</span> :
                    this.state.loadingData ?
                        <CircularProgress /> :
                        <Table selectable={false} bodyStyle={styles.bodyStyle}>
                            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                <TableRow>
                                    {equipmentHistoryTableHeaders.map((header, i) => {
                                        return (
                                            <TableHeaderColumn key={`header-equipmentTable-${header}`} style={styles.columnHeader}>
                                                {strings[header]}
                                            </TableHeaderColumn>
                                        )
                                    })}
                                </TableRow>
                            </TableHeader>
                            <TableBody showRowHover={false} deselectOnClickaway={false} displayRowCheckbox={false}>
                                {this.props.history.map((row, i) => {
                                    return (
                                        <TableRow key={i}>
                                            <TableRowColumn style={styles.columnValue}>
                                                <ClientLocalDateTimeStr
                                                    hierarchyId={row.HierarchyItemId}
                                                    jobId={row.JobId}
                                                    utcTime={row.LocationDateTime}
                                                    formatStr="MM/DD/YYYY h:mma"
                                                />
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>{this.getLevelName(row.HierarchyItemId)}</TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>
                                                <MapColumn
                                                    lat={row.Latitude}
                                                    lng={row.Longitude}
                                                    index={i}
                                                />
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>
                                                <EmployeeNameColumn employee={this.state.employees.find((item) => item.Id === row.EmployeeId)} index={i} />
                                            </TableRowColumn>
                                            <TableRowColumn style={styles.columnValue}>
                                                {row.Note &&
                                                    <i
                                                        className="fa fa-info-circle"
                                                        style={{ color: grey500, cursor: "pointer", fontSize: 16 }}
                                                        title={row.Note}
                                                    />
                                                }
                                            </TableRowColumn>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                            <TF adjustForCheckbox={false}>
                                <TableFooter
                                    total={this.state.total}
                                    offset={this.state.offset}
                                    limit={this.state.limit}
                                    limitOptions={limitOptions}
                                    onPageClick={this.onPageClick}
                                    onLimitChange={this.onLimitChange}
                                />
                            </TF>
                        </Table>
                }
            </div>
        )
    }
}
